export default __webpack_public_path__ + "static/media/log-in-bg.0d10c218.svg";